import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import FaceSwap from "../Screens/FaceSwap";
import CustomNavbar from "../components/Navbar";
import MultipleFaceSwap from "../Screens/MultipleFaceSwap";
import PreweddingFaceSwap from "../Screens/PreweddingFaceSwap";
import BabyshowerFaceSwap from "../Screens/BabyshowerFaceSwap";
import ChatApp from "../Screens/ChatGpt";
import AccountDeletionPage from "../Screens/DietPlanAccountDeletion";

const Router: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const showNavbar = location.pathname !== "/diet-plan/delete-user";
  return (
    <>
      {showNavbar && <CustomNavbar />}
      <Routes>
        <Route path="/" element={<FaceSwap />} />
        <Route path="/faceswap" element={<FaceSwap />} />
        <Route path="/multiple-faceswap" element={<MultipleFaceSwap />} />
        <Route path="/prewedding-faceswap" element={<PreweddingFaceSwap />} />
        <Route path="/babyshower-faceswap" element={<BabyshowerFaceSwap />} />
        <Route path="/diet-plan/delete-user" element={<AccountDeletionPage />} />
        {/* <Route path="/gpt" element={<ChatApp />} /> */}
      </Routes>
    </>
  );
};

export default Router;
